export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0021s_0000_Black-&-White-37.11e542c3.png";